import React from 'react'
import { SuperAdminRouteImport } from './Import'
const { RoutesMap, AddCompany, CompanyList, UpdateCompany, AddCompanyUser, CompanyUserList, UpdateCompanyUser } = SuperAdminRouteImport

const SuperAdminRoute = () => {
    return [
        {
            path: RoutesMap.ADD_COMPANY.path,
            element: <AddCompany />
        },
        {
            path: RoutesMap.UPDATE_COMPANY.path,
            element: <UpdateCompany />
        },
        {
            path: RoutesMap.COMPANY_LIST.path,
            element: <CompanyList />
        },

        {
            path: RoutesMap.ADD_COMPANY_USER.path,
            element: <AddCompanyUser />
        },
        {
            path: RoutesMap.UPDATE_COMPANY_USER.path,
            element: <UpdateCompanyUser />
        },
        {
            path: RoutesMap.COMPANY_USER_LIST.path,
            element: <CompanyUserList />
        },
    ]
}

export default SuperAdminRoute;
